/**
 * What: Shopify sync-history heat grid merchant-facing copy.
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 */
export const shopifyComponentStoreIntelligenceSyncHistoryCopy = {
    storeIntelligenceSyncHistory: {
        daysOfHistoryCollected001: 'days of history collected',
        daysCount002: 'of',
        days003: 'days',
        historyComplete004: 'TestFeed collects up to 60 days of recent order history. Your available history is ready, and new days update automatically.',
        fillingAutomatically005: 'TestFeed collects up to 60 days of recent order history. Your available history updates automatically.',
        inYourNumbers006: 'In your numbers',
        syncingNow007: 'Syncing now',
        actionNeeded008: 'Action needed',
        onItsWay009: 'On its way',
        olderHistory010: 'Older history',
        notYet011: 'Not yet',
        noDataYet012: 'No data yet — on its way automatically.',
        notHappenedYet013: "Hasn't happened yet.",
        keptForRecords014: 'Earlier history',
        historyCompletesOnItsOwn015: 'the rest fills in over the next few days with nothing to do.',
        gettingHistory016: 'Getting your history',
        beforeTestFeedHistory017: 'Before TestFeed history',
    },
};
//# sourceMappingURL=store-intelligence-sync-history.js.map